import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Post height to parent window for iframe auto-resize
function postHeight() {
  if (window.parent !== window) {
    const height = document.documentElement.scrollHeight;
    window.parent.postMessage({ type: 'crisp-signup-height', height }, '*');
  }
}

// Observe DOM changes and report height
const resizeObserver = new ResizeObserver(postHeight);
resizeObserver.observe(document.documentElement);
window.addEventListener('load', postHeight);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
